import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import colors from "app/colors";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    px: 2,
  },
  defaultProps: {
    variant: "outline",
    focusBorderColor: colors.blue,
  },
  variants: {
    outline: {
      field: {
        rounded: "md",
      },
    },
  },
});

export const inputTheme = defineMultiStyleConfig({ baseStyle });
